<script setup lang="ts">
import { processedUrl } from '@padlet/vivaldi-client'
import { computed } from 'vue'

const {
  alt = '',
  src,
  transforms,
} = defineProps<{
  src: string
  width: number
  height: number
  transforms: { [key: string]: string | number }
  alt?: string
}>()

const emit = defineEmits<{
  (e: 'error', error: Event): void
}>()

const processedSrc = computed(() => {
  // For relative urls in development
  if (src.startsWith('/')) return src

  const purl = processedUrl(src, transforms)
  return purl
})

function onError(error: Event) {
  emit('error', error)
}
</script>

<template>
  <img v-if="src" :src="processedSrc" :width="width" :height="height" :alt="alt" @error="onError" />
</template>
